import { CButton } from '@coreui/react-pro'
import React from 'react'
import { BLACK } from '../../../scss/colorConsts'

const BUTTON_STYLES = {
  color: BLACK,
}

// Action buttons appearing when selecting visits in the visit history model
export default function VisitHistoryModalButton({ onClick, type }) {
  return (
    <span key={'VisitHistoryModalButton-' + type}>
      <CButton color="secondary" size="sm" className="ms-2" onClick={onClick} style={BUTTON_STYLES}>
        {type === 'download' && (
          <>
            <i
              style={{ fontSize: '1.2em', marginRight: '4px' }}
              className="fa-light fa-cloud-arrow-down"
            ></i>
            Download
          </>
        )}
        {type === 'copyText' && (
          <>
            <i className="fa-regular fa-copy" style={{ marginRight: '4px', fontSize: '1.1em' }}></i>
            Copy Text
          </>
        )}
        {type === 'continueVisit' && 'Continue Visit'}
        {type === 'continueDraft' && 'Continue from Draft'}
        {type === 'copyVisit' && 'Copy Visit'}
        {type === 'copyVisitAndNote' && 'Copy Visit and Note'}
        {type === 'newNote' && 'New Note'}
        {type === 'completed' && 'View Encounter'}
      </CButton>
    </span>
  )
}
